import { IScheduleGeneralItens } from '../domain/procedure.entities';
import {ProcedureGateway} from '../domain/procedure.gateway';

export class CreateUseCase {
    constructor(private gate: ProcedureGateway) {}

    async execute(params: any): Promise<any> {
         const data = await this.gate.createProcedure(params);
         return data;
    }

    async loadSearchGeneral(id?: string): Promise<IScheduleGeneralItens> {
        return this.gate.loadSearchGeneral(id);
    }

    scheduleDateValidationOnCreate(date: Date) {
        const now = new Date();
        const errorResponse = `
        Atenção,
        devido à proximidade de realização deste procedimento,
        o pedido deverá ser feito exclusivamente por contato telefônico diretamente para o nosso escalador no telefone:
        11-99434-9850
        `;
    
        // Remover horas, minutos, segundos e milissegundos das datas para comparar apenas a data
        const dateOnly = new Date(date);
        dateOnly.setHours(0, 0, 0, 0);
    
        const nowOnly = new Date(now);
        nowOnly.setHours(0, 0, 0, 0);
    
        // Verificar se a data é retroativa
        if (dateOnly < nowOnly) {
            return {
                isError: true,
                text: 'Atenção, não é possível criar agendamento com data passada',
            };
        }
    
        // Definir a data mínima como o dia anterior às 17:00
        const minDateTime = new Date(date);
        minDateTime.setDate(minDateTime.getDate() - 1);
        minDateTime.setHours(17, 0, 0, 0);
    
        if (now > minDateTime) {
            return {
                isError: true,
                text: errorResponse,
            };
        }
    
        return {
            isError: false,
            text: '',
        };
    }    
}
